import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-service-details',
  templateUrl: './hybrid-solar.component.html',
  styleUrls: ['./hybrid-solar.component.scss']
})
export class HybridSolarComponent implements OnInit {

 constructor(private titleService: Title) { }
 
   ngOnInit() {
      this.titleService.setTitle('Hybrid Solar');
   }

}
